import { createSelector } from 'reselect';
import { get, map } from 'lodash/fp';

const getCountries = map(item => ({
  id: item.id,
  label: item.name,
  value: item.id
}));

const countriesSelector = createSelector(
  get('countries.items'),
  getCountries
);

export default countriesSelector;
